export const isBiquadFilterNode = (audioNode) => {
    return 'frequency' in audioNode && 'gain' in audioNode;
};
//# sourceMappingURL=biquad-filter-node.js.map